import { render, staticRenderFns } from "./pdf3.vue?vue&type=template&id=6054e97b&scoped=true"
import script from "./pdf3.vue?vue&type=script&lang=js"
export * from "./pdf3.vue?vue&type=script&lang=js"
import style0 from "./pdf3.vue?vue&type=style&index=0&id=6054e97b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054e97b",
  null
  
)

export default component.exports